<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>CONTENTS</h1>
</header>
<p class="tocfmf"><a class="xref" href="#/chimitchell0007#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/chimitchell0009#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chimitchell0012#ch01">1. Pangea</a></p>
<p class="toc"><a class="xref" href="#/chimitchell0015#ch02">2. Rodinia</a></p>
<p class="toc"><a class="xref" href="#/chimitchell0017#ch03">3. Columbia</a></p>
<p class="toc"><a class="xref" href="#/chimitchell0019#ch04">4. The Unknown Archean</a></p>
<p class="toc"><a class="xref" href="#/chimitchell0022#ch05">5. The Next Supercontinent</a></p>
<p class="toc"><a class="xref" href="#/chimitchell0024#ch06">Epilogue: Surviving Amasia</a></p>
<p class="tocbmf"><a class="xref" href="#/chimitchell0025#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chimitchell0026#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chimitchell0027#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mitchell-0006.vue?4c4e5976